import type { RootState } from '@/store';

export const selectWarnings = (root: RootState) => root?.warnings;
